import { render, staticRenderFns } from "./HistoryImg.vue?vue&type=template&id=296e15c4&scoped=true"
import script from "./HistoryImg.vue?vue&type=script&lang=js"
export * from "./HistoryImg.vue?vue&type=script&lang=js"
import style0 from "./HistoryImg.vue?vue&type=style&index=0&id=296e15c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296e15c4",
  null
  
)

export default component.exports